'use strict';

function CnHeadController() {
  var vm = this;

  vm.$onInit = $onInit;
  vm.setActions = setActions;

  function $onInit() {
    vm.actions = false;
    vm.h = vm.h || 1;
    vm.hr = vm.hr || 1;
    vm.reverse = vm.reverse === true || false;
  }

  function setActions() {
    vm.actions = true;
  }
}

module.exports = CnHeadController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-head/cn-head/cn-head.controller.js
 ** module id = 36
 ** module chunks = 0
 **/